import { useState, useEffect } from 'react';
import api from '../api';

export const useScanHistory = () => {
  const [scanHistory, setScanHistory] = useState([]);
  const [showScanHistory, setShowScanHistory] = useState(false);

  // Fetch scan history on mount
  useEffect(() => {
    async function fetchScanHistory() {
      try {
        const res = await api.get('/scan-history');
        if (Array.isArray(res.data)) setScanHistory(res.data);
      } catch {
        // fallback to localStorage if backend fails
        const stored = localStorage.getItem('scanHistory');
        if (stored) {
          try { 
            setScanHistory(JSON.parse(stored)); 
          } catch {}
        }
      }
    }
    fetchScanHistory();
  }, []);

  // Save to backend whenever scan history changes
  useEffect(() => {
    async function saveScanHistory() {
      try {
        // Only POST the most recent scan (the first in the array)
        if (scanHistory.length > 0) {
          const { barcode, productName, nutrition } = scanHistory[0];
          await api.post('/scan-history', { barcode, productName, nutrition });
        }
      } catch {
        localStorage.setItem('scanHistory', JSON.stringify(scanHistory));
      }
    }
    if (scanHistory.length > 0) saveScanHistory();
  }, [scanHistory]);

  return {
    scanHistory,
    setScanHistory,
    showScanHistory,
    setShowScanHistory,
  };
};
